import React from 'react';
import {
  Typography, Box, LinearProgress,
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { isValidatingCustomerState } from '../../state/apiRequestStatus';

const LinearProgressValidatingCustomer = () => {
  const isValidatingCustomer = useRecoilValue(isValidatingCustomerState);

  if (isValidatingCustomer) {
    return (
      <Box mt={3}>
        <Typography>
          <FormattedMessage id="LinearProgressValidatingCustomer.infoValidatingCustomer" />
        </Typography>
        <Box mt={2}>
          <LinearProgress />
        </Box>
      </Box>
    );
  }

  return null;
};

LinearProgressValidatingCustomer.propTypes = {};

export default LinearProgressValidatingCustomer;
